import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig"; // adjust path if needed
import { useNavigate } from 'react-router-dom';
import './Register.css'; // make sure this path is correct

function Register() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "AdoptLink | Register";
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // const res = await axios.post('http://localhost:8080/api/users', formData);
      const res = await axios.post('/api/users', formData);

      console.log(res.data);
      setMessage('Registered successfully!');
    } catch (error) {
      console.error(error);
      setMessage('Registration failed');
    }
  };

  return (
    <div className="register-container">
      <header>
        <h1>AdoptLink</h1>
      </header>

      <h2>📝 Register</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        /><br /><br />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        /><br /><br />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        /><br /><br />
        <button type="submit">Register</button>
      </form>
      <p>{message}</p>

      <p>Already have an account?</p>
      <button onClick={() => navigate('/login')}>Go to Login</button>
    </div>
  );
}

export default Register;
